import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  header: {
    height: '90px',
    [theme.breakpoints.down('md')]: {
      '& img': {
        height: 'auto',
        objectFit: 'cover',
      },
    },
  },
  headerNavButton: {
    '&:hover': {
      opacity: '0.8',
    },
    cursor: 'pointer',
    padding: '10px',
    margin: '0 15px',
    letterSpacing: 2,
    textTransform: 'uppercase',
    fontSize: '1.2em',
    textDecoration: 'none',
  },
  miniFooter: {
    padding: '20px',
    borderTop: '4px solid #11111190',
    background:
      'linear-gradient(-170deg, #3099ff 0%,#6099ef 40%, #8099ef 100%)',
  },
  floor7: {
    '& > :not(:last-child)': {
      // marginRight: '20px',
    },
  },
}));
